document.addEventListener('DOMContentLoaded', function () {
    const modals = document.querySelectorAll('.show-modal')
    const closeButtons = document.querySelectorAll('.modal .close-button')

    modals.forEach(function (modalButton) {
        modalButton.addEventListener('click', function () {
            const modalId = this.getAttribute('data-modal-id')
            const modal = document.querySelector(`.modal[data-modal-id="${modalId}"]`)

            if (modal) {
                modal.classList.add('open')
                document.body.classList.add('no-scroll')
            }
        })
    })

    closeButtons.forEach(function (closeButton) {
        closeButton.addEventListener('click', function () {
            const modal = this.closest('.modal')

            if (modal && modal.classList.contains('open')) {
                modal.classList.remove('open')
                document.body.classList.remove('no-scroll')
            }
        })
    })
})
